import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class SendSms extends Base {
    constructor(props) {
        super(props);
        this.state = {
            onlySystemTemplates: this.isNull(props.OnlySystemTemplates) ? false : props.OnlySystemTemplates,
            useIn: this.isNull(props.UseIn) ? 'all' : props.UseIn,
            crmTeams: this.isNull(props.CrmTeams) ? 'all' : props.CrmTeams,
            caller: props.Caller,
            mobiles: props.Mobiles,
            data: null,
            loading: true,
            template: this.getDefaultGuid(),
            date: null,
            hour: '',
            minute:''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: this.state.onlySystemTemplates,
            useIn: this.state.useIn,
            crmTeams: this.state.CrmTeams
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/crm/smspanel/bulk", {
            template: this.state.template,
            date: this.convertMomentToDb(this.state.date),
            hour: this.state.hour,
            minute: this.state.minute,  
            mobiles: this.state.mobiles
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("پیام شما با موفقیت ارسال گردید");
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getNumberList(from, to) {
        var list = [];
        for (var i = from; i <= to; i++) {
            list.push(i);
        }
        return list;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth":"90%"}}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">ارسال پیامک</h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">متن پیام:</label>
                                            <select defaultValue={this.state.template} onChange={e => this.state.template = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.data.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                 )}
                                            </select>
                                        </div>
                                    </div>
                                    {/*<div className="col-sm-12 mt-2">*/}
                                    {/*<p>توجه: در صورتیکه قصد دارید تا پیام ها در تاریخ و ساعت خاصی ارسال شوند، فیلدهای زیر را وارد نمایید</p>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-sm-4">*/}
                                    {/*    <div className="form-group">*/}
                                    {/*        <label for="name" className="title1">روز:</label>*/}
                                    {/*        <DatePicker*/}
                                    {/*            inputReadOnly={true}*/}
                                    {/*            className="form-control input-sm persian-date"*/}
                                    {/*            placeholder={"تاریخ"}*/}
                                    {/*            isGregorian={false}*/}
                                    {/*            showTodayButton={true}*/}
                                    {/*            timePicker={false}*/}
                                    {/*            onChange={(e) => { this.state.date = e }}*/}
                                    {/*            value={this.getFormatedDateForDatePicker(this.state.date)}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-sm-4">*/}
                                    {/*    <div className="form-group">*/}
                                    {/*        <label for="name" className="title1">ساعت:</label>*/}
                                    {/*        <select defaultValue={this.state.hour} onChange={e => this.state.hour = e.target.value} autocomplete="off" className="form-control input-sm ltr">*/}
                                    {/*            <option value="">انتخاب کنید</option>*/}
                                    {/*            {this.getNumberList(0,23).map(op=>*/}
                                    {/*                <option value={op}>{op}</option>*/}
                                    {/*            )}*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-sm-4">*/}
                                    {/*    <div className="form-group">*/}
                                    {/*        <label for="name" className="title1">دقیقه:</label>*/}
                                    {/*        <select defaultValue={this.state.minute} onChange={e => this.state.minute = e.target.value} autocomplete="off" className="form-control input-sm">*/}
                                    {/*            <option value="">انتخاب کنید</option>*/}
                                    {/*            {this.getNumberList(0, 59).map(op =>*/}
                                    {/*                <option value={op}>{op}</option>*/}
                                    {/*            )}*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                                <p className="mt-2">پیام فوق برای {this.state.mobiles.length} شماره تماس انتخاب شده ارسال خواهد گردید</p>
                                <p>توجه: بعد از زدن دکمه ارسال بلافاصله درخواست ارسال پیام در وبسرویس پیامکی درج خواهد شد.لذا قبل از زدن دکمه ارسال متن پیامک را کنترل نمایید</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ارسال
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}